/**
 * File: constants.js
 *
 * Use contstants for vendor libraries that create global objects
 * Example: .constant('$', window.$);   //import jquery
 */
(function(){
    angular
        .module('maApp.core')
        .constant('_', window._)
        .constant('appName', 'Integrated Waterbird Management & Monitoring')
        .constant('endpoint', '//' + window.location.host + '/api/v2/')
        .constant('localStorageKeys', {
            //Variables for creating a Plan
            'planYear':'plan_year',
            'planUnits':'plan_units',
            'planPrescription':'plan_prescription'
        })
        .constant('localStoragePrefix', 'pbApp')
        .constant('appHost', window.location.host);
})();